<template>
  <table class="table table-striped table-xs" :id="dataTable.id">
    <thead>
      <tr>
        <th>Período de Pesquisa</th>
        <th>Período de Referência</th>
        <th class="text-center">Detalhes</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="period in periods" :key="period.PS_PERIODO_ID">
        <td>{{ period.PS_PERIODO_NOME }}</td>
        <td>{{ period.PS_PERIODO_REFERENCIA }}</td>
        <td class="text-center">
          <router-link
            :to="`periods/${period.PS_PERIODO_ID}`"
            class="btn btn-outline-primary btn-icon rounded-pill ml-2"
            title="Detalhes"
          >
            <i class="far fa-file-alt"></i>
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import 'datatables.net-dt/js/dataTables.dataTables'
import '@/utils/basicDataTableExtend'

export default {
  name: 'DatatableHome',

  props: {
    periods: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTablePeriods',
        columnDefs: [
          {
            orderable: false,
            width: 130,
            targets: [2],
          },
        ],
      },
    }
  },

  computed: {},

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        order: [0, 'desc'],
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
